// ----------------------------------------------------------------------
// Sector rollups.
//
// The raw `companyType` values on each portfolio entry are inconsistent —
// "Food & Beverage Manufacturing", "Food Production" and "Food and Beverage
// Services" are three labels for one sector. These groups roll them up into a
// short, readable set used by both the homepage hero chips and the portfolio
// filter, so the two can't drift apart.
//
// A company may belong to more than one group (a food manufacturer is both
// Food & Beverage and Manufacturing) and will appear under either filter.
// ----------------------------------------------------------------------

export const SECTOR_GROUPS = [
  { label: 'CPG', match: ['consumer'] },
  { label: 'Food & Beverage', match: ['food', 'beverage'] },
  { label: 'Health & Wellness', match: ['health', 'wellness', 'supplement'] },
  { label: 'Manufacturing', match: ['manufactur'] },
  { label: 'Media & Entertainment', match: ['media', 'entertain', 'audio', 'video'] },
  { label: 'Pet', match: ['pet'] },
  { label: 'Finance', match: ['equity', 'investment', 'advisory', 'capital'] },
  { label: 'Technology', match: ['infrastructure', 'data center', 'tech'] },
];

/** Every group a single companyType string belongs to. */
export function groupsFor(companyType) {
  const type = (companyType || '').toLowerCase();
  if (!type) return [];
  return SECTOR_GROUPS.filter(({ match }) => match.some((m) => type.includes(m))).map(
    ({ label }) => label
  );
}

/** Groups present in a set of projects, in SECTOR_GROUPS order, with counts. */
export function sectorsFrom(projects) {
  const counts = new Map();
  (projects || []).forEach((p) => {
    groupsFor(p.companyType).forEach((label) => {
      counts.set(label, (counts.get(label) || 0) + 1);
    });
  });
  return SECTOR_GROUPS.filter(({ label }) => counts.has(label)).map(({ label }) => ({
    label,
    count: counts.get(label),
  }));
}
